import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import Breadcrumbs from '../breadcrumbs';
import { Main, MainBg, BreadcrumbsEx, MediaContainer, MediaContainerBg, Content, CtaInsideContent, CtaOutsideContent } from './styles';
/*::
import type { Node } from 'react';
import type { LinkType } from '../breadcrumbs';

type MediaType = {|
  node?: Node,
  width?: string,
  position?: 'right' | 'left' | 'bg';
|};
type MobileType = {|
  hideCta?: boolean,
  hideMedia?: boolean,
  imageBelowContent?: boolean,
  fontColor?: string,
|};
type ContentType = {|
  hasBreadcrumbs?: boolean,
  padding?: string,
  fontColor?: string,
  justifyContent?: string,
  alignItems?: string,
|};
type Props = {|
  breadcrumbsHome?: LinkType,
  breadcrumbsLinks?: Array<LinkType>,
  linkComponent?: Node,
  media?: MediaType,
  mobile?: MobileType,
  content?: ContentType,
  cta?: Node,
  children?: Node,
  dir?: 'rtl' | 'ltr';
  rest?: any,
|};
*/

var MediaSection = function MediaSection(_ref
/*: Props */
) {
  var _ref$breadcrumbsHome = _ref.breadcrumbsHome,
      breadcrumbsHome = _ref$breadcrumbsHome === void 0 ? {
    label: 'Home',
    url: '/'
  } : _ref$breadcrumbsHome,
      breadcrumbsLinks = _ref.breadcrumbsLinks,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? 'a' : _ref$linkComponent,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? {
    width: '60rem',
    position: 'right'
  } : _ref$media,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? {
    hasBreadcrumbs: false,
    padding: undefined,
    fontColor: undefined,
    justifyContent: 'flex-start',
    alignItems: 'flex-start'
  } : _ref$content,
      cta = _ref.cta,
      _ref$mobile = _ref.mobile,
      mobile = _ref$mobile === void 0 ? {
    hideCta: false,
    hideMedia: true,
    imageBelowContent: false,
    fontColor: undefined
  } : _ref$mobile,
      children = _ref.children,
      dir = _ref.dir,
      rest = _objectWithoutPropertiesLoose(_ref, ["breadcrumbsHome", "breadcrumbsLinks", "linkComponent", "media", "content", "cta", "mobile", "children", "dir"]);

  var node = media.node,
      width = media.width,
      position = media.position;
  var fontColor = content.fontColor,
      hasBreadcrumbs = content.hasBreadcrumbs;
  var fontColorMobile = mobile.fontColor;
  var MainNode = position === 'bg' ? MainBg : Main;
  var MediaNode = position === 'bg' ? MediaContainerBg : MediaContainer;
  return /*#__PURE__*/React.createElement(MainNode, Object.assign({
    mobileHideCta: mobile.hideCta,
    mobileImageBelowContent: mobile.imageBelowContent,
    fontClr: fontColor,
    fontClrMobile: fontColorMobile,
    "data-test": "media-section-main",
    media: {
      width: width,
      position: position
    },
    dir: dir
  }, rest), breadcrumbsLinks && position !== 'bg' && !hasBreadcrumbs && /*#__PURE__*/React.createElement(Breadcrumbs, {
    home: breadcrumbsHome,
    links: breadcrumbsLinks,
    linkComponent: linkComponent,
    theme: BreadcrumbsEx
  }), /*#__PURE__*/React.createElement(Content, {
    "data-test": "media-section-content",
    media: {
      position: position
    },
    content: content
  }, breadcrumbsLinks && (position === 'bg' || hasBreadcrumbs) && /*#__PURE__*/React.createElement(Breadcrumbs, {
    home: breadcrumbsHome,
    links: breadcrumbsLinks,
    linkComponent: linkComponent,
    theme: BreadcrumbsEx
  }), children, cta && /*#__PURE__*/React.createElement(CtaInsideContent, {
    mobileHideCta: mobile.hideCta,
    mobileImageBelowContent: mobile.imageBelowContent,
    "data-test": "media-section-cta"
  }, cta)), /*#__PURE__*/React.createElement(MediaNode, {
    hideOnMobile: mobile.hideMedia,
    "data-test": "media-section-media"
  }, node), !mobile.imageBelowContent || !cta ? null : /*#__PURE__*/React.createElement(CtaOutsideContent, {
    mobileHideCta: mobile.hideCta,
    mobileImageBelowContent: mobile.imageBelowContent,
    "data-test": "media-section-cta"
  }, cta));
};

export default MediaSection;